import { gettingStarted } from './softwareDefinedStorageforAWSConfig';
export const pagesConfig = [...gettingStarted()];
